import { render } from "./Spinner.vue?vue&type=template&id=42b1a181"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=42b1a181&lang=css"
script.render = render

export default script